export default __webpack_public_path__ + "static/subset-SuisseIntl-Bold-e4d0c5f2352fee14448778135e39cc82.woff";